(function () {
    'use strict';

    a3_cabin_reports.controller('BucketCtrl', BucketCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name BucketCtrl
    * @description 
    *   View bucket
    * @ngInject
    */
    function BucketCtrl($scope, $location, BucketFactory, UserFactory, MessageFactory, $timeout, SettingsMain, defaultBucketDate) {

        var ownDuties = [];
        var sharedDuties = [];
        var approvedDuties = [];

        $scope.state = 'bucketCalendar';
        var user = UserFactory.getUser();
        $scope.isSecure = UserFactory.isSecure();
        $scope.isUserSA = user.position == 'SA' ? true : false;
        $scope.logged_user_info = user.aimsId + ' - ' + user.name;
        $scope.getCalendarData = getCalendarData;
        $scope.showErrorMessage = false;

        var selectedDate = SettingsMain.getCalendarSelectedDate(); //Redirect to month that was previously selected
        SettingsMain.setCalendarSelectedDate(null); //Then reinitialize to current month

        getCalendarData();

        function getCalendarData(){
            progressBarBox(true);
            BucketFactory.getDutyObject(function (responseData) {
                ownDuties = responseData.data.data.Duties;
                sharedDuties = responseData.data.data.SharedDuties;
                approvedDuties = responseData.data.data.ApprovedDuties;
                setupView();
                progressBarBox(false);
            }).catch(function(error) {
                $scope.showErrorMessage = true;
                progressBarBox(false);
                console.error('Load duties error', error.status, error.statusText);
        });
        }
        
        function setupView() {
            if (!UserFactory.isLoggedIn()) {
                $location.path("/login");
            }
            
            $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
            $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();


            /*var ownEvents = formatDuties(ownDuties, true, false);
            if (sharedDuties.length > 0) {
                var sharedEvents = formatDuties(sharedDuties, false, false);
                var events = ownEvents.concat(sharedEvents);
            } else {
                var events = ownEvents;
            }*/
            $scope.notification = createNotification(ownDuties);
            var ownEvents = formatDuties(ownDuties, true, false);
            var events =   ownEvents;
            if(approvedDuties != null || approvedDuties!= undefined){
                if(approvedDuties.length>0){
                    var appvovedEvents = formatDuties(approvedDuties, true, true);
                    var events = events.concat(appvovedEvents);
                }
            }
            calendar(events);
        }


        /**
         * Transform routes in calendar events
         * @memberof BucketCtrl
         * @param {array} routes - The Scheduled Routes 
         * @return {array} events 
         */
        function formatDuties(duties, isOwnDuty, isApproved) {
            var dutiesEvents = [];
            for (var i = 0; i < duties.length; i++) {
                
                if(duties[i].IsUpdated){
                    console.log(duties[i]);
                }
                /*************** Add main event for duty *********************/

                // var eType = (isOwnDuty ? 'own-' : 'shared-') + duties[i].DutyType.toLowerCase();
                var eClassName = getEventClassName(duties[i], isOwnDuty, isApproved);
                var eIcons = getEventIcons(duties[i], isOwnDuty, isApproved);
                var eTitle = getEventTitle(duties[i], isOwnDuty) + ((duties[i].TotalSharedDuties == undefined) ? "" : duties[i].TotalSharedDuties) ;
                var eOtherInfos = getOtherInfos(duties[i], isOwnDuty);
                var event = {
                    _id: duties[i].Id,
                    // type: eType,
                    icons: eIcons,
                    className: eClassName.class,
                    title: eTitle,
                    start : (duties[i].DutyBegin == duties[i].DutyEnd)? duties[i].DutyDateS :duties[i].DutyBegin,
				    end :  (duties[i].DutyBegin == duties[i].DutyEnd)? null : duties[i].DutyEnd,
                    sortOrder: (isOwnDuty ? 1 : -1),
                    otherInfos: eOtherInfos,
                    shareable: duties[i].Shareable,
                    isOwnDuty: isOwnDuty,
                    isApproved: isApproved,
                    isOwnApproved: duties[i].HasApprovedProposals,
                    listViewColor: eClassName.color
                }
                dutiesEvents.push(event);

            }
            return dutiesEvents;
        }
        
        function createNotification(duties){
            var NewPendingProposalsCount = 0;
            var NewApprovedProposalsCount = 0;
            var NewRejectedProposalsCount = 0;
            var notificationText = null;
            
            for (var i = 0; i < duties.length; i++) {
                
                if(duties[i].IsUpdated){
                    if(duties[i].HasApprovedProposals){
                        NewApprovedProposalsCount++;
                    }else{
                        NewPendingProposalsCount += duties[i].NewPendingProposalsCount;
                        NewRejectedProposalsCount += duties[i].NewRejectedProposalsCount;
                    }
                }
            }
            
           /* var notification = {
                        NewPendingProposalsCount : NewPendingProposalsCount,
                        NewApprovedProposalsCount : NewApprovedProposalsCount,
                        NewRejectedProposalsCount : NewRejectedProposalsCount
                    }*/
            
            if((NewPendingProposalsCount + NewApprovedProposalsCount + NewRejectedProposalsCount)>0){
                notificationText = "You have "
                var hasPrevious = false;
                  if(NewPendingProposalsCount){
                      notificationText = notificationText +  NewPendingProposalsCount + " pending";
                      hasPrevious = true;
                  }
                
                 if(NewRejectedProposalsCount){
                      var conjuction = (hasPrevious ? NewApprovedProposalsCount ? ", " :  " and " : "");
                      notificationText = notificationText + conjuction  + NewRejectedProposalsCount + " rejected";
                      hasPrevious = true;
                  }
                
                  if(NewApprovedProposalsCount){
                      var conjuction = (hasPrevious ?  " and " : "" );
                      notificationText = notificationText + conjuction + NewApprovedProposalsCount + " accepted";
                  }
                
                  notificationText = notificationText+ " proposals." ;  
                
               
            }
            
            
            
            return notificationText;
                
        }
    
        /**
         * Returns an array of strings for icons to display in the event tile
         * @memberof BucketCtrl
         * @param {object} duty - The Scheduled duty 
         * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
         * @return {array} icons - The array of strings for icons to display in the event tile.
         */
        function getEventIcons(duty, isOwnDuty, isApproved) {
            var icons = [];
            if (!isOwnDuty) 
                icons.push('fa-sing-in');
            else{
                                if (duty.IsUpdated) icons.push('fa-star text-orange');

              /*  if (duty.PendingProposalsCount > 0 && !isApproved) icons.push('fa-info-circle');*/
                if (!duty.Shareable || isApproved) icons.push('fa-lock');
                if (duty.Shared && !isApproved) icons.push('fa-bitbucket');

                                    

            }
            return icons;
        }

        /**
         * Returns the title for the event tile
         * @memberof BucketCtrl
         * @param {object} duty - The Scheduled duty 
         * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
         * @return {string} title - The title to display in the event tile.
         */
        function getEventTitle(duty, isOwnDuty) {
            var title = '';
            if (isOwnDuty) title += duty.Title;
            else title += 'Shared duties: ';
            return title;
        }

        /**
         * Returns the class for the event tile
         * @memberof BucketCtrl
         * @param {object} duty - The Scheduled duty 
         * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
         * @return {string} className - The class(es) to use for displaying the event tile.
         */
        function getEventClassName(duty, isOwnDuty, isApproved) {
            var eventClass = {class:'fc-bucket ', color:''};
            if (isOwnDuty) {
                eventClass.class += 'fc-own ';
                var hasApprovedTrade = duty.HasApprovedProposals;
                if(isApproved == true) {
                    eventClass.class += 'fc-green-inverted ';
                    eventClass.color = 'lv-green-inverted';
                }
                else if (hasApprovedTrade) {
                    eventClass.class += 'fc-green ';
                    eventClass.color = 'lv-green';
                }
                else if (duty.Shared) {
                    eventClass.class += 'fc-primary-inverted ';
                    eventClass.color = 'lv-blue';
                }
            /*     else if (duty.Shareable && duty.PendingProposalsCount == 0) {
                    eventClass.class += 'fc-blue ';
                    eventClass.color = 'lv-blue';
                } else if (duty.PendingProposalsCount > 0) {
                    eventClass.class += 'fc-orange ';
                    eventClass.color = 'lv-orange';
                } else if (duty.Bookmarks != undefined && duty.Bookmarks.length > 0) {
                    eventClass.class += 'fc-purple-inverted ';
                    eventClass.color = 'lv-purple-inverted';
                } */
                else {
                    eventClass.class += 'fc-white ';
                    eventClass.color = 'lv-white';
                }
            } else {
                eventClass.class += 'fc-aluminum ';
                eventClass.color = 'lv-aluminum';
            }
            return eventClass;
        }

        /**
         * Returns an array of objects for infos (label, number) to display in the event tile
         * @memberof BucketCtrl
         * @param {object} duty - The Scheduled duty 
         * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
         * @return {array} infos - The array of objects for infos (label, number) to display in the event tile.
         */
        function getOtherInfos(duty, isOwnDuty) {
            var infos = [];
            if (isOwnDuty) {
                var hasApprovedTrade = duty.HasApprovedProposals;

                if (!hasApprovedTrade) {
                    if (duty.PendingProposalsCount > 0) infos.push({ label: 'Proposals', num: duty.PendingProposalsCount });
                    if (duty.BookmarksCount > 0) infos.push({ label: 'Bookmarks', num: duty.BookmarksCount });

                    // var totalBookmarks = (duty.bookmarks == undefined ? 0 : duty.bookmarks.length);
                    // if (totalBookmarks > 0) infos.push({ label: 'Bookmarks', num: totalBookmarks.toString() });
                }
            }
            //  else {
            //     if (duty.TotalSharedDuties > 0) infos.push({ label: 'Total', num: duty.TotalSharedDuties.toString() });
            //     //if (duty.unclaimedShared > 0) infos.push({ label: 'Unclaimed', num: duty.unclaimedShared.toString() });
            // }
            return infos;
        }

        function calendar(events) {
            $('#calendar').fullCalendar('destroy');
            
            $("#calendar").fullCalendar({
                defaultView: getDefaultView(),
                defaultDate: defaultBucketDate,
                firstDay: 1,
                lang: 'en',
                editable: false,
                draggable: false,
                selectable: false,
                selectHelper: false,
                unselectAuto: false,
                disableResizing: false,
                droppable: false,
                fixedWeekCount: false,
                nextDayThreshold: "00:00:00",
                header: {
                    left: 'title',
                    center: '',
					right: 'month,listMonth today prev,next'
                },
                timeFormat: 'HH:mm',
                displayEventEnd: true,
                events: events,
                eventOrder: "sortOrder",
                eventRender: function (event, element, icon) {
                    element.find('.fc-title').prepend("<br/>");
                    if($('#calendar').fullCalendar('getView').type === 'listMonth'){
                        element.find('.fc-list-item-title').addClass('listview-icon');
                        $.each(event.className, function (index, icon) {
                            element.addClass(event.listViewColor);
                        });
                        $.each(event.icons, function (index, icon) {
                            element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
                        });
                        
                        if (event.otherInfos != null && event.otherInfos.length > 0) {
                            $.each(event.otherInfos, function (index, info) {
                               if(info.label == 'Proposals')
                                 element.find('.fc-list-item-title').append("<span class='badge badge-primary pull-right'>" + info.num + "</span>");
                            });
                            
                        }
                    }
                    else{
                        if (event.icons != null && event.icons.length > 0) {
                            
                            element.find('.fc-title').prepend("<span class='calendar-icon'></span>");
                            $.each(event.icons, function (index, icon) {
                                element.find('.calendar-icon').append("<i class='fa " + icon + " '></i> ");
                            });
                        }
                        if (event.otherInfos != null && event.otherInfos.length > 0) {
                            $.each(event.otherInfos, function (index, info) {
                                element.find('.fc-title').append("<div class='small text-right'><strong>" + info.label + ": " + info.num + "</strong></div>");
                                 element.find('.fc-list-item-title').add("<span class='badge badge-primary pull-right'>" + info.num + "</span>");
                            });
                            
                        }
                    }
                },
                eventResize: function(event, delta, revertFunc) {
                    changeView(detectMobile(),'#calendar');
                },
                dayRender: function (date, cell) {
                },
                // dayClick: function(date, jsEvent, view) {
                //     $timeout(function(){ gotoDayBucketView(date); })
                // },
                eventClick: function (calEvent, jsEvent, view) {
                    if(calEvent.shareable == true && calEvent.isOwnDuty && (!calEvent.isApproved || calEvent.isOwnApproved)){
                        $timeout(function () { gotoDayBucketView(calEvent._id); });
                    }
                    else if(calEvent.shareable == false && calEvent.isOwnDuty)
                    {
                        if(!calEvent.isApproved){   //don't allow click for approved duty
                            $timeout(function () { unableShare(); });
                        }
                    }
                },
                height: 'auto'
            });
            
               $('.fc-listMonth-button').click(function(){
                SettingsMain.setCalendarViewStyle('listMonth');
            })
            
            $('.fc-month-button').click(function(){
                SettingsMain.setCalendarViewStyle('month');
            })

            if(selectedDate != null && selectedDate != undefined){
                $("#calendar").fullCalendar('gotoDate', selectedDate);
            }
        }

        function getDefaultView(){
                var calendarStyle = SettingsMain.getCalendarViewStyle();
                if (calendarStyle == null){
                    calendarStyle = detectMobile() ? "listMonth" : "month";
                }
                return calendarStyle;
                
            }
            
			function detectMobile() {
				var isMobile =(window.innerWidth <= 800 && window.innerHeight <= 735); 
               
                return isMobile;		
            }	
            
         

        /**
         * Redirects to bucket calendar day 
         * @memberof BucketCtrl
         */
        function gotoDayBucketView(dutyId) {
                $location.path('/bucketDay/' + dutyId);
            }
        }
        function unableShare(){
            bootbox.dialog({
                message: "<div class='alert alert-warning'>You can't share this duty, please try another shareable duty.</div>",
                title: "Warning",
                buttons: {
                    cancel:{
                        label: "Close",
                        className: "btn-default",
                        callback: function(){}
                    }
                }
            })
        }
        function progressBarBox( isOpen ){
            if(isOpen){
                bootbox.dialog({
                    closeButton: false,
                    message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>',
                    //title: "Please wait..."
                });
            }else {
                bootbox.hideAll();
            }

        }

})();